import {QUOTE_ITEM_LENS_TYPE} from 'constants/lensType';
import {QuoteItemEyeglassesType} from 'constants/flow/flowTypesCart';

/**
 * Get increase sum if lenses type is equal to the given
 *
 * @param {string} lensTypeSelected - desired lens type
 * @param {Array<QuoteItemType>} items - quote items
 * @returns {number} - summary qty items by lens type
 */
export const increaseByLensesType = (
    lensTypeSelected: $Values<typeof QUOTE_ITEM_LENS_TYPE>,
    items: Array<QuoteItemEyeglassesType>,
) =>
    items.reduce(
        (sum: number, {qty, lens_type: lensType}) =>
            lensType === lensTypeSelected ? sum + Number(qty) : sum,
        0,
    );
